import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["conditional", "forward", "heading", "errors", "formatButton", "lessonType"]
  static values = { restorePreferences: Boolean, formName: { type: String, default: "ondemand_publication" } }

  connect() {
    this.restoreLastLessonType()
    if (this.hasFormatButtonTarget) this.formatButtonTarget.hidden = true
    this.refresh()
    const target = this.hasErrorsTarget ? this.errorsTarget : this.headingTargets.find((heading) => !heading.closest("[hidden]"))
    target?.focus({ preventScroll: true })
    window.scrollTo({ top: 0 })
  }

  restoreLastLessonType() {
    if (!this.restorePreferencesValue) return

    this.restorePreferencesValue = false
    if (!this.hasLessonTypeTarget) return

    try {
      const saved = localStorage.getItem("teacher-panel:last-class-lesson-type")
      if (Array.from(this.lessonTypeTarget.options).some((option) => option.value === saved && !option.disabled)) {
        this.lessonTypeTarget.value = saved
      }
    } catch {
      // Keep the default when browser storage is unavailable.
    }
  }

  rememberLessonType() {
    if (!this.hasLessonTypeTarget) return

    try {
      localStorage.setItem("teacher-panel:last-class-lesson-type", this.lessonTypeTarget.value)
    } catch {
      // Keep the form usable when browser storage is unavailable.
    }
  }

  changeFormat() {
    this.element.requestSubmit(this.formatButtonTarget)
  }

  refresh() {
    this.conditionalTargets.forEach((element) => {
      const controls = this.element.querySelectorAll(`[name="${this.formNameValue}[${element.dataset.whenField}]"]`)
      const control = Array.from(controls).find((input) => input.type !== "hidden" && (input.type !== "radio" || input.checked)) || controls[0]
      element.hidden = !element.dataset.whenValues.split(" ").includes(control?.value)
    })
  }

  continueStep(event) {
    if (event.target.closest(".ts-wrapper")) return
    if (event.isComposing || !event.target.matches('input[type="text"], input[type="url"], input[type="number"]')) return

    event.preventDefault()
    if (this.hasForwardTarget && !this.forwardTarget.disabled) this.element.requestSubmit(this.forwardTarget)
  }
}
